export const RECAPTCHA_SITE_KEY = '6Le8KF0jAAAAAEmjE1lknNAgLAgyLFI7VLCHGa4C'
